var token = document.head.querySelector('meta[name="csrf-token"]').getAttribute('content');
$('.lds-spinner').click(function(e) {
	$(this).removeClass('static');
});

function aspect_ratio(selector, x, y){
	var selector = $('.'+selector);
	var w = selector.width();
	var ratio = w*y/x;
	// var h = w.height();
	selector.height(parseInt(ratio));
}

// $(function() {
//     suscribiteme('emailSubscription', 'showMessage');
//     suscribiteme('emailSubscription_top', 'showMessage_top');
// });

// function suscribiteme(id, id_loader) {
//     $('form#'+ id +' button[type="submit"]').click(function(e) {
//         var correo = $('form#'+ id +' input[type="email"]');
//         if (correo.val() != '') {
//             $('#'+ id_loader +'.loading_only').show();
//             console.log(correo.val());
//         }
//     });
// }

aspect_ratio('card_fix_img', 4, 3);
aspect_ratio('img_slide_recetas', 2, 1);

$(document).ready(function() {

	$(function() {
		// drag vertical post paginados.
		let searchParams = new URLSearchParams(window.location.search)
	    let getparamP = searchParams.has('p');
	    let getparamM = searchParams.has('m');
	    let param = searchParams.get('p');
	    if (getparamP) {
        	goToAnchor('setPosts');
        	goToAnchor('setPosts_t');
	    }
	    if (getparamM) {
        	goToAnchor('setPosts_cal');
        	goToAnchor('setRecetas');
        	goToAnchor('setPosts_b');
        	goToAnchor('setLugares');
	    }

	    function goToAnchor(id){
	    	if ($('#'+id).length) {
		        $('html, body').animate({
		           'scrollTop':   $('#'+id).offset().top
		        }, 1500);
	        }
	    }
	});

	// compra de productos
	var precio = $('.precio_total').text();
	$('.cantidad_productos').change(function (e){
		var cantidad = $(this).val();

		var precio_final = parseFloat(precio)*parseFloat(cantidad);

		$('.precio_total').text(precio_final);
		$('.buyer_cantidad').val(cantidad);

		console.log(precio_final);

	});

	function notas_relacionadas_video(){
		var device_w = $(window).outerWidth();
		if ( device_w > 991 ) {
			var hnota = $('.box-video-articulo .nota_relacionada').outerHeight();
			$('.box-video-articulo iframe').height(parseInt(hnota));
		} else {
			$('.box-video-articulo iframe').height(428);
			// console.log('estoy aqui');
		}
	}

	aspect_ratio('img_slider_post', 1, 1);
	aspect_ratio('img_post_vertical', 1, 1.5);
	aspect_ratio('img_post_horizontal', 2, 1);
	aspect_ratio('img_colaboradores', 77, 100);
	aspect_ratio('img_somelier_top', 409, 528);
	aspect_ratio('grilla_variada', 3, 4);
	aspect_ratio('ratio_4a3', 4, 3);
	aspect_ratio('ratio_1a1', 1, 1);
	aspect_ratio('img_siema_v', 277, 511);
	aspect_ratio('img_siema_carousel', 1000, 536);

	$(window).resize(function(e) {
		aspect_ratio('card_fix_img', 4, 3);
		aspect_ratio('img_slide_recetas', 2, 1);
		aspect_ratio('img_slider_post', 1, 1);
		aspect_ratio('img_post_vertical', 1, 1.5);
		aspect_ratio('img_post_horizontal', 2, 1);
		aspect_ratio('img_colaboradores', 77, 100);
		aspect_ratio('img_somelier_top', 409, 528);
		aspect_ratio('grilla_variada', 3, 4);
		aspect_ratio('ratio_4a3', 4, 3);
		aspect_ratio('ratio_1a1', 1, 1);
		aspect_ratio('img_siema_v', 277, 511);
		aspect_ratio('img_siema_carousel', 1000, 536);
		notas_relacionadas_video();
		var width_device = $(window).outerWidth();
		if (width_device >= 992 ) {
			$(".mainheader .login-reg").show();
		}

	});

	notas_relacionadas_video();

	// var recaptcha = $('.g-recaptcha-response');
 //    if(recaptcha) {
 //        recaptcha.attr('required', 'required');
 //    }

	$('.scrollbar-dynamic').scrollbar();

	// $('input#fecha_nacimiento').datepicker({
	//     format: "dd/mm/yyyy",
	//     language: "es"
	// });

	$('.popup_only').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		closeBtnInside: false,
		fixedContentPos: true,
		mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
		image: {
			verticalFit: true
		},
		zoom: {
			enabled: true,
			duration: 300 // don't foget to change the duration also in CSS
		}
	});

	$('.zoom-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: function(item) {
				return item.el.attr('title');
			}
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}

	});

	$('.checkbox_suscripcion input[type="radio"]').click(function(){
    	var target = $(this).val();
        if (target == 'contacto') {
	        $('#suscripcion').addClass('bg-orange');
	        $('#suscripcion').removeClass('bg-blue');
	        $('#form_contacto').show();
	        $('#form_pago_online').hide();
        } else if (target == 'pagoOnline') {
	        $('#suscripcion').removeClass('bg-orange');
	        $('#suscripcion').addClass('bg-blue');
	        $('#form_contacto').hide();
	        $('#form_pago_online').show();
        }
    });

    $('.get_menu_mobile').click(function(e) {
    	$(".main_menu.menu_responsive").stop().animate({left:"0px"}, 500);
    	$('.overlay_menu').show();
    	$('body').css('overflow','hidden');
    });

    $('.overlay_menu').click(function(event) {
    	$(this).hide();
    	$(".main_menu.menu_responsive").stop().animate({left:"-230px"}, 500);
    	$('body').css({overflow: 'auto'});
    });

    $('body').click(function(e) {

    	if ($(window).outerWidth() <= 991 ) {
    		$(".mainheader .login-reg").stop().animate({right:"-86px"}, 500);
    		setTimeout(function(){
			  $(".mainheader .login-reg").hide();
			}, 500);
    	} else if ($(window).outerWidth() <= 767 ) {
    		$(".mainheader .login-reg").stop().animate({right:"-70px"}, 500);
    		setTimeout(function(){
			  $(".mainheader .login-reg").hide();
			}, 500);
    	} else{
    		$(".mainheader .login-reg").show();
    	}

    });

    $('.get_menu_user').click(function(e) {

    	var left = $(".mainheader .login-reg").position().left;
    	var ancho = $(window).width();

    	console.log(left);

    	if ( ancho == left + 70 ) {
    		$(".mainheader .login-reg").stop().animate({right:"-70px"}, 500);
    		setTimeout(function(){
			  $(".mainheader .login-reg").hide();
			}, 500);
    	} else if( ancho == left + 86 ) {
    		$(".mainheader .login-reg").stop().animate({right:"-86px"}, 500);
    		setTimeout(function(){
			  $(".mainheader .login-reg").hide();
			}, 500);
    	} else {
    		$(".mainheader .login-reg").show();
    		$(".mainheader .login-reg").stop().animate({right:"0px"}, 500);
    	}

    	e.stopPropagation();
    });

    function showModal(id)
	{
		$('#'+id).modal('show');
	}

	function showModalBancard() {
		$('#infoClient').modal('show');
	}

	if ( typeof openPopup !== 'undefined' && openPopup == 'registerModal' ) {
		showModal(openPopup);
	}

	if ( typeof mail_confirmation !== 'undefined' && mail_confirmation == 'confirmationModal' ) {
		showModal(mail_confirmation);
	}
	if ( typeof update_cuenta !== 'undefined' && update_cuenta == 'updateCuentaModal' ) {
		showModal(update_cuenta);
	}

	if ( typeof checkout_bancard !== 'undefined' && checkout_bancard == 'checkoutBancard' ) {
		showModal(checkout_bancard);
	}

	if ( typeof infoClient !== 'undefined' && infoClient == 'infoClient' ) {
		showModal(infoClient);
	}

	$('.mainheader nav .dropdown-menu .dropdown-item.active').parent().parent().addClass('parent_active');

	// filter_grid_normal('filter_grid_normal', 'grid_normal');
	// filter_grid_normal('filter_grid_normal_2', 'grid_normal_2');

	function filter_grid_normal(group_buttons, grid_target)
	{
		$('.'+ group_buttons).on( 'click', 'button', function() {
			$('.'+ group_buttons + ' button').removeClass('active');
			$(this).addClass('active');
			var filterValue = $(this).attr('data-filter');
			var $grid = $('.'+grid_target +' .grid_n');
			var $grid_filter = $('.'+grid_target +' .grid_n'+filterValue);
			if (filterValue == '*') {
				$grid.show();
			} else {
				$grid.hide();
				$grid_filter.show();

			}
			// console.log($grid);
        });
	}

    category_provider('filter_grid_normal');
	function category_provider(content_category) {
        $('.'+ content_category).on( 'click', 'button', function() {
            $('.'+ content_category + ' button').removeClass('active');
            $(this).addClass('active');
            let categoryValue = $(this).attr('data-filter');
            // console.log(categoryValue);
            $('#content_styles').html('<style>.grid_provider .encabezado_proveedor {display: none}.grid_provider .encabezado_proveedor.'+ categoryValue + ' {display: flex}</style>');
            if (categoryValue != '*') {
                // traemos todos los filtros de esa categoria
                let url = '/providers/premium/'+categoryValue;
                $.post( url, { _token: token }, function(response){
                    if (response) {
                        $(".filter_subcategory").html(response);
                        $('#provider_subcategories').show();
                    } else {
                        $('#provider_subcategories').hide();
                    }
                    // console.log(response);
                });
                // traemos todos los proveedores premium de esa categoria
                let url_ = 'providers/premium/get_providers/'+categoryValue;
                $.post( url_, { _token: token }, function (response) {
                    $('#provider_premium').hide();
                    $('#provider_premium_ajax').html(response);
                });

            } else {
                $('#content_styles').html('');
                $('#provider_subcategories').hide();
                //
                $('#provider_premium').show();
                $('#provider_premium_ajax').html('');
            }
        });
    }
    filter_provider('filter_subcategory');
    function filter_provider(content_filter) {
        $('.'+ content_filter).on( 'click', 'button', function() {
            $('.'+ content_filter + ' button').removeClass('active');
            $(this).addClass('active');
            let filterValue = $(this).attr('data-filter');

            // traemos todos los proveedores premium de este filtro
            let url_ = 'providers/premium/get_providers_filters/'+filterValue;
            $.post( url_, { _token: token }, function (response) {
                $('#provider_premium').hide();
                $('#provider_premium_ajax').html(response);
            });

            // filtrando los proveedores free
            $('#content_styles').html('<style>.grid_provider .encabezado_proveedor {display: none}.grid_provider .encabezado_proveedor.'+ filterValue + ' {display: flex}</style>');
        });
    }

});
